import { Route, Switch } from 'react-router-dom';
import { ROUTES } from '../../constants/routes';
import { Partners } from './pages/Partners';
import { AddPromotion } from './pages/AddPromotion';
import { AddPartner } from './pages/AddPartner';
import { DetailPartner } from './pages/DetailPartner';
import { DetailPromotion } from './pages/DetailPromotion';
import { History } from './pages/History';
import { CreatePackage } from './pages/CreatePackage';
import { EditPackage } from './pages/EditPackage';

export const PartnersRoutes = () => (
  <Switch>
    <Route path={ROUTES.PARTNERS} exact component={Partners} />
    <Route path={ROUTES.PARTNERS_ADD_PARTNER} component={AddPartner} />
    <Route path={ROUTES.PARTNERS_ADD_PROMOTION} component={AddPromotion} />
    <Route path={ROUTES.PARTNERS_COPY_PROMOTION} component={AddPromotion} />
    <Route path={ROUTES.PARTNERS_DETAIL_PROMOTION} component={DetailPromotion} />
    <Route path={ROUTES.PARTNERS_DETAIL_PARTNER} component={DetailPartner} />
    <Route path={ROUTES.PARTNERS_HISTORY_PARTNER} component={History}/>
    <Route path={ROUTES.PARTNERS_HISTORY_PROMOTION} component={History}/>
    <Route path={ROUTES.PARTNERS_CREATE_PACKAGE} component={CreatePackage}/>
    <Route path={ROUTES.PARTNERS_EDIT_PACKAGE} component={EditPackage}/>
  </Switch>
);

export default PartnersRoutes;
